"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function default_1(options) {
  var _a;

  var serviceRootUrl = ((_a = options) === null || _a === void 0 ? void 0 : _a.serviceRootUrl) || process.env.SERVICE_ROOT_URL || 'https://europe-west1-wino-production.cloudfunctions.net';
  return {
    ENDPOINT: serviceRootUrl,
    AUTH_ENDPOINT: "".concat(serviceRootUrl, "/auth"),
    DATA_ENDPOINT: "".concat(serviceRootUrl, "/data"),
    STORAGE_ENDPOINT: "".concat(serviceRootUrl, "/storage"),
    PAY_ENDPOINT: "".concat(serviceRootUrl, "/pay")
  };
}

exports.default = default_1;